import React from 'react';

const Footer = () => (
  <footer style={{ margin: 'auto auto 10px auto' }}>
    Copyright © 2022 All right reserved | Project by Yonas Tesfu
  </footer>
);
export default Footer;
